/* eslint-disable no-unused-expressions */
//Handle Pages of Menu Bar (RegisterPage)//
import React, { useRef, useState, useEffect, useContext } from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuItem from '@material-ui/core/MenuItem';
import { Button, Card, FormLabel, TextField } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Typography } from '@material-ui/core';

import RegisterForm from '../../forms/Register/RegisterForm';
import EditPatientForm from '../../forms/Edit_ShowRecords/EditPatientForm'

import RHServiceForm from '../../forms/SRHService/RHServiceForm';
import RHServiceEditForm from '../../forms/SRHService/RHServiceEditForm'
import FPServiceForm from '../../forms/SRHService/FPServiceForm';
import FPServiceEditForm from '../../forms/SRHService/FPServiceEditForm';
import EditFPForm from '../../forms/Edit_ShowRecords/EditFPForm';
import EditRHForm from '../../forms/Edit_ShowRecords/EditRHForm';
import ANCServiceForm from '../../forms/Maternal_HealthService/ANCServiceForm'
import EditANCForm from '../../forms/Edit_ShowRecords/EditANCForm';
import ANCServiceEditForm from '../../forms/Maternal_HealthService/ANCServiceEditForm';
import DeliveryServiceForm from '../../forms/Maternal_HealthService/DeliveryServiceForm';
import EditDeliveryForm from '../../forms/Edit_ShowRecords/EditDeliveryForm';
import DeliveryServiceEditForm from '../../forms/Maternal_HealthService/DeliveryServiceEditForm';
import PNCServiceForm from '../../forms/Maternal_HealthService/PNCServiceForm';
import EditPNCForm from '../../forms/Edit_ShowRecords/EditPNCForm';
import PNCServiceEditForm from '../../forms/Maternal_HealthService/PNCServiceEditForm';
import EditMDSRForm from '../../forms/Edit_ShowRecords/EditMDSRForm';
import EditCFRMForm from '../../forms/Edit_ShowRecords/EditCFRMForm'
import GMServiceForm from '../../forms/GerenalService/GMServiceForm';
import EditGMForm from '../../forms/Edit_ShowRecords/EditGMForm';
import EWARForm from '../../forms/GerenalService/EWARForm';
import EditEWARForm from '../../forms/Edit_ShowRecords/EditEWARForm';
import CustomIDSearchDialog from '../controls/CustomIDSearchDialog';
import NavBarDefaultMainPage from '../../components/Default/NavBarDefaultMainPage';

import OTPForm from '../../forms/IMAM_OTP/OTPForm';
import EditOTPForm from '../../forms/Edit_ShowRecords/EditOTPForm';
import OTPEditForm from '../../forms/IMAM_OTP/OTPEditForm';
import SFPForm from '../../forms/IMAM_SFP/SFPForm';
import EditSFPForm from '../../forms/Edit_ShowRecords/EditSFPForm';
import SFPEditForm from '../../forms/IMAM_SFP/SFPEditForm';
import HTSForm from '../../forms/HTS/HTSForm'
import EditHTSForm from '../../forms/Edit_ShowRecords/EditHTSForm'
import HTSEditForm from '../../forms/HTS/HTSEditForm'

import IPDServiceForm from '../../forms/GerenalService/IPDServiceForm';
import EditIPDForm from '../../forms/Edit_ShowRecords/EditIPDForm';
import IPDServiceEditForm from '../../forms/GerenalService/IPDServiceEditForm';

import HEForm from '../../forms/GerenalService/HEForm';
import EditHEForm from '../../forms/Edit_ShowRecords/EditHEForm';
import HEEditForm from '../../forms/GerenalService/HEEditForm';

import ANCReport from '../../forms/Reports_Exports/ANCReport';
import DeliveryReport from '../../forms/Reports_Exports/DeliveryReport';
import PNCReport from '../../forms/Reports_Exports/PNCReport';
import FPReport from '../../forms/Reports_Exports/FPReport';
import RHReport from '../../forms/Reports_Exports/RHReport';
import GMReport from '../../forms/Reports_Exports/GMReport';
import HeadCountReport from '../../forms/Reports_Exports/HeadCountReport';
import FPRHReport from '../../forms/Reports_Exports/FPRHReport';
import ExportByProvidedDate from '../../forms/Reports_Exports/ExportByProvidedDate';
import ExportByProvidedDateDashboard from '../../forms/Reports_Exports/ExportByProvidedDateDashboard';
import ExportRegisterOnly from '../../forms/Reports_Exports/ExportRegisterOnly';
//import ExportSQL from '../../forms/Reports_Exports/ExportSQL';
import ExportCFRM from '../../forms/Reports_Exports/ExportCFRM';
import ExportEWAR from '../../forms/Reports_Exports/ExportEWAR';
import ExportMDSR from '../../forms/Reports_Exports/ExportMDSR'
import ANCVisitCount from '../../forms/Reports_Exports/ANCVisitCount';

import EditAgeForm from '../../forms/Edit_ShowRecords/EditAgeForm';
import DeleteServiceForm from '../../forms/Edit_ShowRecords/DeleteServiceForm'
import DeleteRegisterForm from '../../forms/Edit_ShowRecords/DeleteRegisterForm'

import MDSRServiceForm from '../../forms/Maternal_HealthService/MDSRServiceForm';
import MDSRServiceEditForm from '../../forms/Maternal_HealthService/MDSRServiceEditForm'

import CFRMForm from '../../forms/CFRM/CFRMForm'
import CFRMEditForm from '../../forms/CFRM/CFRMEditForm'

import UIDailyReport from '../../forms/Reports_Exports/UIDailyReport'

import EntryHomePageDashboard from './EntryHomePageDashboard';

//////////////API/////////////////
import * as service from "../../modals/service";
import * as clinic from "../../modals/clinicbyorgproj"
import * as village from "../../modals/villagebyorgproj"
import * as editAge from "../../modals/editageshow"
import * as delSer from "../../modals/deleteserviceshow"
import * as delReg from "../../modals/deleteregshow"
import { getDiagnosis, getIMCI } from "../../modals/diagnosis"

import Modals from '../modal';

import _ from 'lodash';

/////// Context /////////
import { RegPatientContext } from '../context/regPatient';


/////// API /////////
import { editShow } from "../../modals/editShow";
import LoginForm from '../../forms/Login/LoginForm';
import GMServiceEditForm from '../../forms/GerenalService/GMServiceEditForm';
import EWAREditForm from '../../forms/GerenalService/EWAREditForm';
import ExportHE from '../../forms/Reports_Exports/ExportHE';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}

        {...props}
    />
));

const drawerWidth = 220;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        /* background: '#d91d4c', */
        background: '#482642',
        height: 50,
        justifyContent: 'center',
    },
    toolBar: {
        /* background: '#d91d4c', */
        background: '#482642',
        justifyContent: 'space-around',
    },
}));

const EntryPageMenu = props => {

    //Dashboard Show Control
    const [dashboardShow, setDashboardShow] = useState(false)

    //Register Show Control
    const [registerShow, setRegisterShow] = useState(true)

    //Maternal Show Control
    const [maternalAnchorEl, setMaternalAnchorEl] = useState(null);
    const [ANCShow, setANCShow] = useState(false)
    const [delShow, setDelShow] = useState(false)
    const [PNCShow, setPNCShow] = useState(false)
    const [MDSRShow, setMDSRShow] = useState(false)

    //SRH Show Control
    const [SRHAnchorEl, setSRHAnchorEl] = useState(null);
    const [FPShow, setFPShow] = useState(false)
    const [RHShow, setRHShow] = useState(false)

    //GM Show Control
    const [GMAnchorEl, setGMAnchorEl] = useState(null);
    const [GMShow, setGMShow] = useState(false)
    const [HEShow, setHEShow] = useState(false)
    const [CFRMShow, setCFRMShow] = useState(false)
    const [EWARShow, setEWARShow] = useState(false)

    //CrossCutting
    const [CCAnchorEl, setCCAnchorEl] = useState(null);

    //IPD,OPD,Surgery
    const [IPDShow, setIPDShow] = useState(false)
    const [OPDShow, setOPDShow] = useState(false)
    const [surgeryShow, setSurgeryShow] = useState(false)

    //OTP and SFP
    const [IMAMAnchorEl, setIMAMAnchorEl] = useState(null);
    const [OTPShow, setOTPShow] = useState(false)
    const [SFPShow, setSFPShow] = useState(false)
    const [HTSShow, setHTSShow] = useState(false)

    //Report/Export Show Control
    const [reportsAnchorEl, setReportsAnchorEl] = useState(null);
    const [HCReportShow, setHCReportShow] = useState(false)
    const [ANCReportShow, setANCReportShow] = useState(false)
    const [DelReportShow, setDelReportShow] = useState(false)
    const [PNCReportShow, setPNCReportShow] = useState(false)
    const [FPReportShow, setFPReportShow] = useState(false)
    const [RHReportShow, setRHReportShow] = useState(false)
    const [GMReportShow, setGMReportShow] = useState(false)
    const [FPRHReportShow, setFPRHReportShow] = useState(false)
    const [exportProvidedShow, setExportProvidedShow] = useState(false)
    const [exportInsertShow, setExportInsertShow] = useState(false)
    const [exportEWARShow, setExportEWARShow] = useState(false)
    const [exportMDSRShow, setExportMDSRShow] = useState(false)
    const [exportHEShow, setExportHEShow] = useState(false)
    const [ANCVisitShow, setANCVisitShow] = useState(false)
    const [dailyReportShow, setDailyReportShow] = useState(false)

    //Edit Show Control
    const [editAnchorEl, setEditAnchorEl] = useState(null);
    const [patientEditShow, setPatientEditShow] = useState(false)
    const [patientEditFormShow, setPatientEditFormShow] = useState(false)
    const [ANCEditShow, setANCEditShow] = useState(false)
    const [ANCEditFormShow, setANCEditFormShow] = useState(false)
    const [DelEditShow, setDelEditShow] = useState(false)
    const [DelEditFormShow, setDelEditFormShow] = useState(false)
    const [PNCEditShow, setPNCEditShow] = useState(false)
    const [PNCEditFormShow, setPNCEditFormShow] = useState(false)
    const [MDSREditShow, setMDSREditShow] = useState(false)
    const [MDSREditFormShow, setMDSREditFormShow] = useState(false)
    const [FPEditShow, setFPEditShow] = useState(false)
    const [FPEditFormShow, setFPEditFormShow] = useState(false)
    const [RHEditShow, setRHEditShow] = useState(false)
    const [RHEditFormShow, setRHEditFormShow] = useState(false)
    const [GMEditShow, setGMEditShow] = useState(false)
    const [GMEditFormShow, setGMEditFormShow] = useState(false)
    const [EWAREditShow, setEWAREditShow] = useState(false)
    const [EWAREditFormShow, setEWAREditFormShow] = useState(false)
    const [CFRMEditShow, setCFRMEditShow] = useState(false)
    const [CFRMEditFormShow, setCFRMEditFormShow] = useState(false)
    const [HEEditShow, setHEEditShow] = useState(false)
    const [HEEditFormShow, setHEEditFormShow] = useState(false)
    const [OTPEditShow, setOTPEditShow] = useState(false)
    const [OTPEditFormShow, setOTPEditFormShow] = useState(false)
    const [SFPEditShow, setSFPEditShow] = useState(false)
    const [SFPEditFormShow, setSFPEditFormShow] = useState(false)
    const [HTSEditShow, setHTSEditShow] = useState(false)
    const [HTSEditFormShow, setHTSEditFormShow] = useState(false)
    const [IPDEditShow, setIPDEditShow] = useState(false)
    const [OPDEditShow, setOPDEditShow] = useState(false)
    const [surgeryEditShow, setSurgeryEditShow] = useState(false)
    const [IPDEditFormShow, setIPDEditFormShow] = useState(false)
    const [OPDEditFormShow, setOPDEditFormShow] = useState(false)
    const [surgeryEditFormShow, setSurgeryEditFormShow] = useState(false)
    const [ageEditShow, setAgeEditShow] = useState(false)
    const [deleteServiceShow, setDeleteServiceShow] = useState(false)
    const [deleteRegisterShow, setDeleteRegisterShow] = useState(false)

    const [openSnack, setOpenSnack] = useState(false)

    //ID Search Dialog
    const [dialogOpen, setDialogOpen] = useState(false)
    const [ageDialogOpen, setAgeDialogOpen] = useState(false)
    const [deleteServiceDialogOpen, setDeleteServiceDialogOpen] = useState(false)
    const [deleteRegisterDialogOpen, setDeleteRegisterDialogOpen] = useState(false)
    const [gmDialogOpen, setGMDialogOpen] = useState(false)
    const [patient, setPatient] = useState([])
    const [serviceType, setServiceType] = useState()
    const [patientGender, setPatientGender] = useState()
    const [clinicData, setClinicData] = useState([])
    const [villageData, setVillageData] = useState([])
    const [diagnosisData, setDiagnosisData] = useState([])
    const [imciData, setImciData] = useState([])
    const [hptDiagnosisData, setHptDiagnosisData] = useState([])
    const [editAgeData, setEditAgeData] = useState([])
    const [deleteServiceData, setDeleteServiceData] = useState([])
    const [deleteRegisterData, setDeleteRegisterData] = useState([])

    const history = useHistory();
    const classes = useStyles();

    /////// Context /////////
    const form = useContext(LoginForm)

    ///////Background Data///////////
    const [loading, setLoading] = useState(false);
    const [regPatient, setRegPatient] = useState([])

    //For regPatient Data Context
    const { regPatientData, setRegPatientData } = useContext(RegPatientContext);

    ////////////UI Btn Show (base on Org and Project)/////////////
    const [regBtn, setRegBtn] = useState(false)
    const [maternalBtn, setMaternalBtn] = useState(false)
    const [GMBtn, setGMBtn] = useState(false)
    const [imamBtn, setImamBtn] = useState(false)
    const [imamSfpBtn, setImamSfpBtn] = useState(false)
    const [SRHBtn, setSRHBtn] = useState(false)
    const [ICDBtn, setICDBtn] = useState(false)
    const [unicefBtn, setUnicefBtn] = useState(false)
    const [siriBtn, setSiriBtn] = useState(false)
    const [IPDBtn, setIPDBtn] = useState(false)
    const [deleteRegBtn, setDeleteRegBtn] = useState(false)

    useEffect(() => {
        const fn = async () => {
            if (sessionStorage.getItem('org') === 'CPI-165') {
                setRegBtn(false)
                setMaternalBtn(false)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(false)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(false)
                setUnicefBtn(false)
            }
            else if (sessionStorage.getItem('project') === 'P-050') {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(true)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            else if ((sessionStorage.getItem('project') === 'P-027') && (sessionStorage.getItem('org') === 'CPI-20' || sessionStorage.getItem('org') === 'CPI-163')) {
                setRegBtn(true)
                setMaternalBtn(false)
                setGMBtn(false)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(true)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }

            else if (sessionStorage.getItem('project') === 'P-016' && (sessionStorage.getItem('org') === 'CPI-15' || sessionStorage.getItem('org') === 'CPI-05')) {
                setRegBtn(true)
                setMaternalBtn(false)
                setGMBtn(true)
                setImamBtn(true)
                setImamSfpBtn(true)
                setSRHBtn(false)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            else if (sessionStorage.getItem('project') === 'P-007' && (sessionStorage.getItem('org') === 'CPI-01' || sessionStorage.getItem('org') === 'CPI-11'
                || sessionStorage.getItem('org') === 'CPI-14')) {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(true)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            //sessionStorage.getItem('project') === 'P-990' || sessionStorage.getItem('project') === 'P-989'
            else if (sessionStorage.getItem('project') === 'P-990') {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(false)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(true)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            //Unicef
            else if (sessionStorage.getItem('project') === 'P-016' && (sessionStorage.getItem('org') === 'CPI-06' || sessionStorage.getItem('org') === 'CPI-07' || sessionStorage.getItem('org') === 'CPI-34')) {
                setRegBtn(false)
                setMaternalBtn(false)
                setGMBtn(false)
                setImamBtn(true)
                setImamSfpBtn(true)
                setSRHBtn(false)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(false)
                setUnicefBtn(true)
            }
            else if (sessionStorage.getItem('project') === 'P-016' && (sessionStorage.getItem('org') === 'CPI-08' || sessionStorage.getItem('org') === 'CPI-19' || sessionStorage.getItem('org') === 'CPI-21')) {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(true)
                setImamSfpBtn(true)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            else if (sessionStorage.getItem('project') === 'P-001' && (sessionStorage.getItem('org') === 'CPI-05' || sessionStorage.getItem('org') === 'CPI-06'
                || sessionStorage.getItem('org') === 'CPI-07')) {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
            else if (sessionStorage.getItem('project') !== 'P-008' && (sessionStorage.getItem('org') === 'CPI-05' || sessionStorage.getItem('org') === 'CPI-20')) {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }

            else if (sessionStorage.getItem('project') !== 'P-008') {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }

            else {
                setRegBtn(true)
                setMaternalBtn(true)
                setGMBtn(true)
                setImamBtn(false)
                setImamSfpBtn(false)
                setSRHBtn(true)
                setICDBtn(false)
                setSiriBtn(false)
                setIPDBtn(false)
                setDeleteRegBtn(true)
                setUnicefBtn(false)
            }
        }
        fn();
    }, [])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editRHPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, true, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editRHPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editFPPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editFPPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editANCPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editANCPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editDeliPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, true, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editDeliPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editPNCPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editPNCPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editGMPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editGMPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editEWAR') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, true, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editEWAR')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editHE') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false,
                    false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, true, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editHE')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editOTPPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, true, false, false,
                    false, false, false, false, false, false, false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editOTPPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editSFPPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, true,
                    false, false, false, false, false, false, false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editSFPPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editHTS') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, true
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editHTS')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editIPDPatient') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, true
                    , false, false, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editIPDPatient')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editMDSR') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false
                    , false, true, false
                    , false, false, false
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editMDSR')])

    useEffect(() => {
        const fn = async () => {
            //sessionStorage.setItem('editPatient', false)
            if (sessionStorage.getItem('editCFRM') === 'true') {
                showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
                    , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
                    false, false, false, false, false, false,
                    false, false, false, false, false, false, false, false, false
                    , false, false, false
                    , false, false, true
                    , false, false, false
                    , false, false, false, false //EWAR
                    , false //MDSR Export
                    , false, false, false, false, false //ANCVisitCount
                    , false //Daily Report
                    , false) //Dashboard
            }
        }
        fn();
    }, [sessionStorage.getItem('editCFRM')])

    //Snack Bar
    const setSnackBarOpen = () => {
        setOpenSnack(true)
    }
    const setSnackBarClose = () => {
        setOpenSnack(false)
    }

    //Dialog
    const setDialogOpenControl = () => {
        setPatient([])
        setVillageData([])
        setClinicData([])
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.removeItem('rhage');
        sessionStorage.removeItem('rhageunit');
        sessionStorage.removeItem('rhageunitvalue');
        setDialogOpen(true)
    }
    const setDialogCloseControl = async (value, type) => {

        if (value && type === 'search') {
            await sessionStorage.setItem('searchid', value.trim())
            await setLoading(true)
            const patient = await service.getPatient()
            const clinicbyorgproj = await clinic.getClinicByOrgProj()
            const villagebyorgproj = await village.getVillageByOrgProj()
            if (clinicbyorgproj && patient.data.data.getPatient.length === 1 && villagebyorgproj) {
                setClinicData(clinicbyorgproj.data.data.getClinicByOrgProj)
                setVillageData(villagebyorgproj.data.data.getVillageByOrgProj)
                console.log("Searvice Search Patient Length===>", patient.data.data.getPatient.length)
                const type = patient.data.data.getPatientType
                console.log("Patient Type=>", type[0].SERCNT === null)
                setPatient(patient.data.data.getPatient)
                setServiceType(type[0].SERCNT)
                setPatientGender(patient.data.data.getPatient[0].REGSEX)
                //console.log(patient.data.data.getPatient[0].REGSEX)
                setLoading(false)
                setDialogOpen(false)
                console.log("Clinic by org project => ", clinicbyorgproj.data.data.getClinicByOrgProj);
                console.log("Village by org project => ", villagebyorgproj.data.data.getVillageByOrgProj);
            }
            else {
                setLoading(false)
                setDialogOpen(false)
            }

        }
        else {
            await setDialogOpen(false)
        }
    }

    //GM Dialog
    const setGMDialogOpenControl = () => {
        setPatient([])
        setClinicData([])
        setVillageData([])
        setDiagnosisData([])
        setImciData([])
        setHptDiagnosisData([])
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.removeItem('rhage');
        sessionStorage.removeItem('rhageunit');
        sessionStorage.removeItem('rhageunitvalue');
        setGMDialogOpen(true)
    }
    const setGMDialogCloseControl = async (value, type) => {

        if (value && type === 'search') {
            await sessionStorage.setItem('searchid', value.trim())
            await setLoading(true)
            const patient = await service.getPatient()
            const clinicbyorgproj = await clinic.getClinicByOrgProj()
            const villagebyorgproj = await village.getVillageByOrgProj()
            const diagnosis = await getDiagnosis()
            const imci = await getIMCI()
            if (clinicbyorgproj && patient.data.data.getPatient.length === 1 && villagebyorgproj && diagnosis && imci) {
                setClinicData(clinicbyorgproj.data.data.getClinicByOrgProj)
                setVillageData(villagebyorgproj.data.data.getVillageByOrgProj)
                setDiagnosisData(diagnosis.data.data.getDiagnosis)
                setImciData(imci.data.data.getIMCI)
                setHptDiagnosisData(diagnosis.data.data.getHPTDiagnosis)
                console.log("Searvice Search Patient Length===>", patient.data.data.getPatient.length)
                console.log("diagnosis data => ", diagnosis.data.data.getDiagnosis)
                console.log("IMCI data => ", imci.data.data.getIMCI)
                const type = patient.data.data.getPatientType
                console.log("Patient Type=>", type[0].SERCNT)
                setPatient(patient.data.data.getPatient)
                setServiceType(type[0].SERCNT)
                setPatientGender(patient.data.data.getPatient[0].REGSEX)
                //console.log(patient.data.data.getPatient[0].REGSEX)
                setLoading(false)
                setGMDialogOpen(false)
                console.log("Clinic by org project => ", clinicbyorgproj.data.data.getClinicByOrgProj);
                console.log("Village by org project => ", villagebyorgproj.data.data.getVillageByOrgProj);
            }
            else {
                setLoading(false)
                setGMDialogOpen(false)
            }

        }
        else {
            await setGMDialogOpen(false)
        }
    }

    /////Edit Age,Delete Service,Delete Reg////////////////
    const setAgeDialogOpenControl = () => {
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.removeItem('rhage');
        sessionStorage.removeItem('rhageunit');
        sessionStorage.removeItem('rhageunitvalue');
        setAgeDialogOpen(true)
    }
    const setAgeDialogCloseControl = async (value, type) => {
        if (value && type === 'search') {
            setLoading(true)
            const parameter = {
                regID: value.trim(),
                orgID: sessionStorage.getItem('org')
            }
            const ageData = await editAge.editAgeShow(parameter)
            if (ageData) {
                console.log("Age Data =====> ", ageData.data.data.editAgeShow)
                setEditAgeData(ageData.data.data.editAgeShow)
                setLoading(false)
                setAgeDialogOpen(false)
            }
            else {
                setLoading(false)
                setAgeDialogOpen(false)
            }

        }
        else {
            await setAgeDialogOpen(false)
        }
    }

    const setDeleteServiceOpenControl = () => {
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.removeItem('rhage');
        sessionStorage.removeItem('rhageunit');
        sessionStorage.removeItem('rhageunitvalue');
        setDeleteServiceDialogOpen(true)
    }
    const setDeleteServiceCloseControl = async (value, type) => {
        if (value && type === 'search') {
            setLoading(true)
            const parameter = {
                regID: value.trim(),
                orgID: sessionStorage.getItem('org')
            }
            const delData = await delSer.deleteServiceShow(parameter)
            if (delData) {
                console.log("Age Data =====> ", delData.data.data.deleteServiceShow)
                setDeleteServiceData(delData.data.data.deleteServiceShow)
                setLoading(false)
                setDeleteServiceDialogOpen(false)
            }
            else {
                setLoading(false)
                setDeleteServiceDialogOpen(false)
            }

        }
        else {
            await setDeleteServiceDialogOpen(false)
        }
    }

    const setDeleteRegisterOpenControl = () => {
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.removeItem('rhage');
        sessionStorage.removeItem('rhageunit');
        sessionStorage.removeItem('rhageunitvalue');
        setDeleteRegisterDialogOpen(true)
    }
    const setDeleteRegisterCloseControl = async (value, type) => {
        if (value && type === 'search') {
            setLoading(true)
            const parameter = {
                regID: value.trim(),
                orgID: sessionStorage.getItem('org')
            }
            const delData = await delReg.deleteRegShow(parameter)
            if (delData) {
                console.log("Age Data =====> ", delData.data.data.deleteRegShow)
                setDeleteRegisterData(delData.data.data.deleteRegShow)
                setLoading(false)
                setDeleteRegisterDialogOpen(false)
            }
            else {
                setLoading(false)
                setDeleteRegisterDialogOpen(false)
            }

        }
        else {
            await setDeleteRegisterDialogOpen(false)
        }
    }

    //Change Button Text Color and Style when clicked
    const changeColor = (id, click) => {
        if (click) {
            document.getElementById(id).style.color = '#ed767f'
            document.getElementById(id).style.textShadow = "0px 0px 10px #d91d4d";
        }
        else {
            document.getElementById(id).style.color = 'white'
            document.getElementById(id).style.textShadow = "0px 0px 0px #fff";
        }
    }


    //Dashboard
    const dashboardHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , true) //Dashboard
    }

    //Register
    const registerHandleClick = () => {
        showHandle(true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        history.push('entrypage')
    };

    //Maternal Health
    const maternalHealthHandleClick = (event) => {
        setMaternalAnchorEl(event.currentTarget);
    };
    const maternalHandleClose = () => {
        setMaternalAnchorEl(null);
    };

    const ANCServiceHandleClick = async () => {
        await setMaternalAnchorEl(null);
        await setDialogOpenControl()

        await sessionStorage.setItem('tblName', 'tbl_anc');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard

    }
    const deliServiceHandleClick = async () => {
        await setMaternalAnchorEl(null);
        await setDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_delivery');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, true, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard

    }
    const PNCServiceHandleClick = async () => {
        await setMaternalAnchorEl(null);
        await setDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_pnc');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, true, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard

    }

    const MDSRHandleClick = async () => {
        await setMaternalAnchorEl(null);
        await sessionStorage.setItem('tblName', 'tbl_mdsr');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , true, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard

    }

    //SRHServices
    const SRHHandleClick = (event) => {
        setSRHAnchorEl(event.currentTarget)
    };
    const SRHHandleClose = () => {
        setSRHAnchorEl(null);
    };
    const RHServiceHandleClick = async () => {
        await setSRHAnchorEl(null);
        await setDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_rh');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, true, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const FPServiceHandleClick = async () => {
        await setSRHAnchorEl(null);
        await setDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_fp');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, true, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    //General Services
    const GMHandleClick = (event) => {
        setGMAnchorEl(event.currentTarget)
    };
    const GMHandleClose = () => {
        setGMAnchorEl(null);
    };
    const GMServiceHandleClick = async () => {
        await setGMAnchorEl(null);
        await setGMDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_gm');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const HEHandleClick = async () => {
        await setGMAnchorEl(null);
        //await setGMDialogOpenControl()
        //await sessionStorage.setItem('tblName', 'tbl_ewar');
        //sessionStorage.setItem('serviceName', 'ewar')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , true, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const EWARHandleClick = async () => {
        await setGMAnchorEl(null);
        //await setGMDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_ewar');
        sessionStorage.setItem('serviceName', 'ewar')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , true, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const OPDServiceHandleClick = async () => {
        await setGMAnchorEl(null);
        await setGMDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_medopd');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', true)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            true, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const surgeryServiceHandleClick = async () => {
        await setGMAnchorEl(null);
        await setGMDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_surgopd');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', true)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, true, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const IPDServiceHandleClick = async () => {
        await setGMAnchorEl(null);
        await setGMDialogOpenControl()
        await sessionStorage.setItem('tblName', 'tbl_ipd');
        sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, true, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    //CrossCutting
    const CCHandleClick = (event) => {
        setCCAnchorEl(event.currentTarget)
    };
    const CCHandleClose = () => {
        setCCAnchorEl(null);
    };

    const CFRMHandleClick = async () => {
        await setCCAnchorEl(null);
        await sessionStorage.setItem('tblName', 'tbl_gm');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , true, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    //OTP and SFP and HTS
    const IMAMHandleClick = (event) => {
        setIMAMAnchorEl(event.currentTarget)
    };
    const IMAMHandleClose = () => {
        setIMAMAnchorEl(null);
    };
    const OTPHandleClick = async () => {
        setIMAMAnchorEl(null);
        sessionStorage.setItem('tblName', 'tbl_imamotpn');
        sessionStorage.setItem('serviceName', 'imamotp')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            true, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard


    };

    const SFPHandleClick = async () => {
        setIMAMAnchorEl(null);
        sessionStorage.setItem('tblName', 'tbl_imamsfpn');
        sessionStorage.setItem('serviceName', 'imamsfp')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, true, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard


    };

    const HTSHandleClick = async () => {
        setIMAMAnchorEl(null);
        sessionStorage.setItem('tblName', 'tbl_hts');
        sessionStorage.setItem('serviceName', 'hts')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , true, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard


    };

    //Reports & Exports
    const reportsHandleClick = (event) => {
        setReportsAnchorEl(event.currentTarget);
    };
    const reportsHandleClose = () => {
        setReportsAnchorEl(null);
    };
    const ANCReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const DeliveryReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const PNCReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, true, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const FPReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, true, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const RHReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const GMReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, true, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const HeadCountReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, true, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const FPRHReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, true, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const exportProvidedDateHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const dailyReportHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false,
            false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , true //Daily Report
            , false) //Dashboard
    }

    const editAgeHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        //setAgeDialogOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const exportEWARHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        //setAgeDialogOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, true //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const exportHEHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        //setAgeDialogOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, true, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const ANCVisitCountHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        //setAgeDialogOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, true //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }


    const exportSQLFile = () => {
        setReportsAnchorEl(null);
        //setAgeDialogOpenControl()
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        //sessionStorage.setItem('serviceName', 'gm')
        //sessionStorage.setItem('tblName', 'tbl_gm')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false,
            false, false, false, false, false, false
            , false, false, false, false
            , false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const exportCFRMHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const exportMDSRHandleClick = () => {
        setReportsAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , true //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    //Edit/Show Records
    const editHandleClick = (event) => {
        setEditAnchorEl(event.currentTarget);
    };
    const editHandleClose = () => {
        setEditAnchorEl(null);
    };
    const editPatientHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editANCHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_anc');
        sessionStorage.setItem('serviceName', 'an')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editDeliHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_delivery');
        sessionStorage.setItem('serviceName', 'deli')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editPNCHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_pnc');
        sessionStorage.setItem('serviceName', 'pn')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, true, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const editMDSRHandleClick = async () => {
        await setEditAnchorEl(null);
        await sessionStorage.setItem('tblName', 'tbl_mdsr');
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        await showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, true
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard

    }

    const editRHHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_rh');
        sessionStorage.setItem('serviceName', 'rh')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, true, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editFPHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_fp');
        sessionStorage.setItem('serviceName', 'fp')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, false, false, false, false,
            false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editGMHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_gm');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '1');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, true, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editHEHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        //sessionStorage.setItem('tblName', 'tbl_ewar');
        //sessionStorage.setItem('serviceName', 'ewar')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, true, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editEWARHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_ewar');
        sessionStorage.setItem('serviceName', 'ewar')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, true, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editCFRMHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_cfrm');
        sessionStorage.setItem('serviceName', 'cfrm')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, true, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editOTPHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_imamotpn');
        sessionStorage.setItem('serviceName', 'imamotp')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, true, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editSFPHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_imamsfp');
        sessionStorage.setItem('serviceName', 'imamsfp')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, true, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editHTSHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_imamsfp');
        sessionStorage.setItem('serviceName', 'imamsfp')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, true, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editOPDHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_medopd');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('gmgmtype', '3');
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, true, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editSurgeryHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_surgopd');
        sessionStorage.setItem('serviceName', 'gm')
        sessionStorage.setItem('gmgmtype', '2');
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, true, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }
    const editIPDHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        sessionStorage.setItem('tblName', 'tbl_ipd');
        sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, true, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }

    const deleteServiceHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        setDeleteServiceOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, true, false, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }


    const deleteRegisterHandleClick = () => {
        setEditAnchorEl(null);
        sessionStorage.setItem('homeUpdate', '')
        sessionStorage.setItem('homeSave', '')
        setDeleteRegisterOpenControl()
        //sessionStorage.setItem('tblName', 'tbl_ipd');
        //sessionStorage.setItem('serviceName', 'ipd')
        sessionStorage.setItem('editPatient', false)
        sessionStorage.setItem('editRHPatient', false)
        sessionStorage.setItem('editFPPatient', false)
        sessionStorage.setItem('editANCPatient', false)
        sessionStorage.setItem('editDeliPatient', false)
        sessionStorage.setItem('editPNCPatient', false)
        sessionStorage.setItem('editGMPatient', false)
        sessionStorage.setItem('editEWAR', false)
        sessionStorage.setItem('editSFPPatient', false)
        sessionStorage.setItem('editOTPPatient', false)
        sessionStorage.setItem('OPDPatient', false)
        sessionStorage.setItem('surgeryPatient', false)
        sessionStorage.setItem('editOPDPatient', false)
        sessionStorage.setItem('editSurgeryPatient', false)
        sessionStorage.setItem('editIPDPatient', false)
        sessionStorage.setItem('editMDSR', false)
        sessionStorage.setItem('editHTS', false)
        sessionStorage.setItem('editHE', false)
        sessionStorage.setItem('editANCVisit', false)
        sessionStorage.setItem('editCFRM', false)
        sessionStorage.setItem('gmgmtype', '');
        showHandle(false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false
            , false, false, false, false, false, false, false, false, false, false, true, false, false, false, false, false, false,
            false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false
            , false, false, false
            , false, false, false
            , false, false, false
            , false, false, false, false //EWAR
            , false //MDSR Export
            , false, false, false, false, false //ANCVisitCount
            , false //Daily Report
            , false) //Dashboard
    }


    //26 parameter (GM not include)
    const showHandle = (reg, anc, del, pnc, fp, rh, hcr, ancr, delr, pncr, fpr, rhr, gmr, fprhr, exp, exi, pe, ance, dele, pnce, fpe, rhe, rhef, gme, agee,
        deleteService, deleteRegister, fpef, ancef, delef, pncef, gm, gmef, otp, sfp, otpe, otpef, sfpe, sfpef,
        opd, sur, ipd, opde, sure, ipde, opdef, suref, ipdef, mdsr, mdsref, mdsre, cfrm, cfrme, cfrmef, hts, htse, htsef, ewar, eware, ewaref, ewarexp, mdsrexp, he, hee, heef, heexp, ancvc, daily, dashboard) => {
        setRegisterShow(reg) //1
        setANCShow(anc) //2
        setDelShow(del) //3
        setPNCShow(pnc) //4
        setFPShow(fp) //5
        setRHShow(rh) //6
        setHCReportShow(hcr) //7
        setANCReportShow(ancr) //8
        setDelReportShow(delr) //9
        setPNCReportShow(pncr) //10
        setFPReportShow(fpr) //11
        setRHReportShow(rhr) //12
        setGMReportShow(gmr) //13
        setFPRHReportShow(fprhr) //14
        setExportProvidedShow(exp) //15
        setExportInsertShow(exi) // 16
        setPatientEditShow(pe) //17
        setANCEditShow(ance) //18
        setDelEditShow(dele) //19
        setPNCEditShow(pnce) //20
        setFPEditShow(fpe) //21
        setRHEditShow(rhe) //22
        setRHEditFormShow(rhef) //23
        setGMEditShow(gme) //24
        setAgeEditShow(agee) //25
        setDeleteServiceShow(deleteService) //26
        setDeleteRegisterShow(deleteRegister) //27
        setFPEditFormShow(fpef)
        setANCEditFormShow(ancef)
        setDelEditFormShow(delef)
        setPNCEditFormShow(pncef)
        setGMShow(gm)
        setGMEditFormShow(gmef)
        setOTPShow(otp)
        setSFPShow(sfp)
        setOTPEditShow(otpe)
        setOTPEditFormShow(otpef)
        setSFPEditShow(sfpe)
        setSFPEditFormShow(sfpef)
        setOPDShow(opd)
        setSurgeryShow(sur)
        setIPDShow(ipd)
        setOPDEditShow(opde)
        setSurgeryEditShow(sure)
        setIPDEditShow(ipde)
        setOPDEditFormShow(opdef)
        setSurgeryEditFormShow(suref)
        setIPDEditFormShow(ipdef)
        setMDSRShow(mdsr)
        setMDSREditFormShow(mdsref)
        setMDSREditShow(mdsre)
        setCFRMShow(cfrm)
        setCFRMEditShow(cfrme)
        setCFRMEditFormShow(cfrmef)
        setHTSShow(hts)
        setHTSEditShow(htse)
        setHTSEditFormShow(htsef)
        setEWARShow(ewar)
        setEWAREditShow(eware)
        setEWAREditFormShow(ewaref)
        setExportEWARShow(ewarexp)
        setExportMDSRShow(mdsrexp)
        setHEShow(he)
        setHEEditShow(hee)
        setHEEditFormShow(heef)
        setExportHEShow(heexp)
        setANCVisitShow(ancvc)
        setDailyReportShow(daily)
        setDashboardShow(dashboard)
        sessionStorage.setItem('editPatient', false)
    }

    return (
        <div>
            <NavBarDefaultMainPage />
            <div className={classes.root}>
                <Modals open={loading} />
                <CssBaseline />
                <Card square={true}>
                    <AppBar
                        position="relative"
                        className={classes.appBar}>
                        <Toolbar className={classes.toolBar}>
                            <Button
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                style={{ background: '#482642', color: 'white' }}
                                onClick={dashboardHandleClick} > Dashboard </Button>
                            {regBtn &&
                                <Button
                                    id="regMenu"

                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    style={{ background: '#482642', color: 'white' }}
                                    onClick={registerHandleClick} > Register </Button>}
                            {maternalBtn
                                &&
                                <>
                                    <Button
                                        id="ancMenu"
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        style={{ background: '#482642', color: 'white' }}
                                        onClick={maternalHealthHandleClick}>  Maternal Health  </Button>
                                    <StyledMenu
                                        id="styleMenu"
                                        anchorEl={maternalAnchorEl}
                                        keepMounted
                                        TransitionComponent={Fade}
                                        open={Boolean(maternalAnchorEl)}
                                        onClose={maternalHandleClose}>
                                        <MenuItem onClick={ANCServiceHandleClick}>ANC Service</MenuItem>
                                        <MenuItem onClick={deliServiceHandleClick}>Del Service</MenuItem>
                                        <MenuItem onClick={PNCServiceHandleClick}>PNC Service</MenuItem>
                                        {sessionStorage.getItem('project') !== 'P-050' &&
                                            <MenuItem onClick={MDSRHandleClick}>MDSR</MenuItem>}

                                        {/*  {sessionStorage.getItem('project') === 'P-001' ?
                                            <MenuItem onClick={MDSRHandleClick}>MDSR</MenuItem> : null} */}
                                    </StyledMenu>
                                </>}
                            {SRHBtn &&
                                <>
                                    <Button
                                        id="srhMenu"
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        style={{ background: '#482642', color: 'white' }}
                                        onClick={SRHHandleClick}>  SRH Services  </Button>
                                    <StyledMenu
                                        id="simple-menu"
                                        anchorEl={SRHAnchorEl}
                                        keepMounted
                                        TransitionComponent={Fade}
                                        open={Boolean(SRHAnchorEl)}
                                        onClose={SRHHandleClose}>
                                        {(ICDBtn && SRHBtn && !siriBtn) && <MenuItem onClick={FPServiceHandleClick}>FP Service</MenuItem>}
                                        {(siriBtn && SRHBtn && !ICDBtn) && <MenuItem onClick={RHServiceHandleClick}>RH Service</MenuItem>}
                                        {(!ICDBtn && SRHBtn && !siriBtn) && <>
                                            <MenuItem onClick={FPServiceHandleClick}>FP Service</MenuItem>
                                            <MenuItem onClick={RHServiceHandleClick}>RH Service</MenuItem>
                                        </>
                                        }
                                    </StyledMenu>
                                </>}
                            {
                                IPDBtn &&
                                <>
                                    <Button
                                        id="gmIPDMenu"
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        style={{ background: '#482642', color: 'white' }}
                                        onClick={GMHandleClick} > General Services </Button>
                                    <StyledMenu
                                        id="simple-menu"
                                        anchorEl={GMAnchorEl}
                                        keepMounted
                                        TransitionComponent={Fade}
                                        open={Boolean(GMAnchorEl)}
                                        onClose={GMHandleClose}>
                                        <MenuItem onClick={OPDServiceHandleClick}>OPD-Service(Medical)</MenuItem>
                                        <MenuItem onClick={surgeryServiceHandleClick}>Surgery Service</MenuItem>
                                        <MenuItem onClick={IPDServiceHandleClick}>IPD Service</MenuItem>
                                    </StyledMenu>

                                </>
                            }
                            {GMBtn && <>
                                <Button
                                    id="gmMenu"
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    style={{ background: '#482642', color: 'white' }}
                                    onClick={GMHandleClick} > General Services </Button>
                                <StyledMenu
                                    id="simple-menu"
                                    anchorEl={GMAnchorEl}
                                    keepMounted
                                    TransitionComponent={Fade}
                                    open={Boolean(GMAnchorEl)}
                                    onClose={GMHandleClose}>
                                    {sessionStorage.getItem('org') !== 'CPI-165' &&
                                        <>
                                            <MenuItem onClick={GMServiceHandleClick}>GM Service</MenuItem>
                                            <MenuItem onClick={EWARHandleClick}>EWAR</MenuItem>
                                        </>}

                                    {(sessionStorage.getItem('org') === 'CPI-01' || sessionStorage.getItem('org') === 'CPI-11' || sessionStorage.getItem('org') === 'CPI-165') &&
                                        <><MenuItem onClick={HEHandleClick}>HE</MenuItem></>}
                                </StyledMenu>
                            </>}
                            {sessionStorage.getItem('org') !== 'CPI-165' &&
                                <>
                                    <Button
                                        id="gmMenu"
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        style={{ background: '#482642', color: 'white' }}
                                        onClick={CCHandleClick} > Cross<br />Cutting</Button>
                                    <StyledMenu
                                        id="simple-menu"
                                        anchorEl={CCAnchorEl}
                                        keepMounted
                                        TransitionComponent={Fade}
                                        open={Boolean(CCAnchorEl)}
                                        onClose={CCHandleClose}>
                                        <MenuItem onClick={CFRMHandleClick}>CFRM</MenuItem>

                                    </StyledMenu>
                                </>}

                            {imamBtn &&
                                <>
                                    <Button
                                        id="imamMenu"
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        style={{ background: '#482642', color: 'white' }}
                                        onClick={IMAMHandleClick} >IMAM & PMTCT</Button>
                                    <StyledMenu
                                        id="simple-menu"
                                        anchorEl={IMAMAnchorEl}
                                        keepMounted
                                        TransitionComponent={Fade}
                                        open={Boolean(IMAMAnchorEl)}
                                        onClose={IMAMHandleClose}>
                                        <MenuItem onClick={OTPHandleClick}>IMAM-OTP</MenuItem>
                                        <MenuItem onClick={SFPHandleClick}>IMAM-SFP</MenuItem>
                                        <MenuItem onClick={HTSHandleClick}>HTS Register</MenuItem>
                                    </StyledMenu>
                                </>}
                            <Button
                                id="reportMenu"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                style={{ background: '#482642', color: 'white' }}
                                onClick={reportsHandleClick}>  Reports & Exports  </Button>
                            <StyledMenu
                                id="simple-menu"
                                anchorEl={reportsAnchorEl}
                                keepMounted
                                TransitionComponent={Fade}
                                open={Boolean(reportsAnchorEl)}
                                onClose={reportsHandleClose}>
                                {sessionStorage.getItem('org') !== 'CPI-165' &&
                                    <>
                                        {(ICDBtn && !siriBtn && !unicefBtn) &&
                                            <>
                                                <MenuItem onClick={HeadCountReportHandleClick}>All Reports(ICD)</MenuItem>
                                                <MenuItem onClick={ANCReportHandleClick}>Case Load Head Count Reports(ICD)</MenuItem>
                                                <MenuItem onClick={DeliveryReportHandleClick}>Case Load Comulative Reports(ICD)</MenuItem>
                                                <MenuItem onClick={PNCReportHandleClick}>Case Load Referral Reports(ICD)</MenuItem>

                                            </>}
                                        {(!ICDBtn && !siriBtn && !unicefBtn) &&
                                            <>
                                                <MenuItem onClick={HeadCountReportHandleClick}>Head Count Reports</MenuItem>
                                                <MenuItem onClick={ANCReportHandleClick}>ANC Reports</MenuItem>
                                                <MenuItem onClick={DeliveryReportHandleClick}>Delivery Reports</MenuItem>
                                                <MenuItem onClick={PNCReportHandleClick}>PNC Reports</MenuItem>
                                                <MenuItem onClick={FPReportHandleClick}>FP Reports</MenuItem>
                                                <MenuItem onClick={RHReportHandleClick}>RH Care Services</MenuItem>
                                                <MenuItem onClick={GMReportHandleClick}>General Mobidity Reports</MenuItem>
                                                <MenuItem onClick={FPRHReportHandleClick}>Description (FP+RH)</MenuItem>
                                                <MenuItem onClick={exportCFRMHandleClick}>Export By Date (CFRM)</MenuItem>
                                                <MenuItem onClick={exportMDSRHandleClick}>Export By Date (MDSR)</MenuItem>
                                                {/* {sessionStorage.getItem('org') === 'CPI-99' && <MenuItem onClick={exportCFRMHandleClick}>Export By Date (CFRM)</MenuItem>} */}
                                            </>}
                                        {sessionStorage.getItem('project') === 'P-050' &&
                                            <>
                                                <MenuItem onClick={HeadCountReportHandleClick}>Head Count Reports</MenuItem>
                                                <MenuItem onClick={ANCReportHandleClick}>ANC Reports</MenuItem>
                                                <MenuItem onClick={DeliveryReportHandleClick}>Delivery Reports</MenuItem>
                                                <MenuItem onClick={PNCReportHandleClick}>PNC Reports</MenuItem>
                                                <MenuItem onClick={FPReportHandleClick}>FP Reports</MenuItem>
                                                <MenuItem onClick={RHReportHandleClick}>RH Care Services</MenuItem>
                                                <MenuItem onClick={GMReportHandleClick}>General Mobidity Reports</MenuItem>
                                                <MenuItem onClick={FPRHReportHandleClick}>Description (FP+RH)</MenuItem>
                                                <MenuItem onClick={exportCFRMHandleClick}>Export By Date (CFRM)</MenuItem>
                                                {/* {sessionStorage.getItem('org') === 'CPI-99' && <MenuItem onClick={exportCFRMHandleClick}>Export By Date (CFRM)</MenuItem>} */}
                                            </>}
                                        {(!ICDBtn && siriBtn && sessionStorage.getItem('project') !== 'P-050') &&
                                            <>
                                                <MenuItem onClick={RHReportHandleClick}>RH Care Services</MenuItem>

                                            </>}
                                        <MenuItem onClick={exportProvidedDateHandleClick}>Export Dataset (Facility)</MenuItem>
                                        <MenuItem onClick={editAgeHandleClick}>Export Register Only</MenuItem>
                                        <MenuItem onClick={exportEWARHandleClick}>Export EWAR</MenuItem>
                                        {/* <MenuItem onClick={ANCVisitCountHandleClick} >ANC Visit Count</MenuItem> */}
                                    </>}

                                {(sessionStorage.getItem('org') === 'CPI-01' || sessionStorage.getItem('org') === 'CPI-11' || sessionStorage.getItem('org') === 'CPI-165') &&
                                    <><MenuItem onClick={exportHEHandleClick}>Export HE</MenuItem></>}
                                {/* <MenuItem onClick={exportSQLFile}>Export Database Backupfile </MenuItem> */}
                                <MenuItem onClick={dailyReportHandleClick}>Daily Data Entry</MenuItem>
                            </StyledMenu>
                            <Button
                                id="editMenu"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                style={{ background: '#482642', color: 'white' }}
                                onClick={editHandleClick}> Edit/Show Records </Button>
                            <StyledMenu
                                id="simple-menu"
                                anchorEl={editAnchorEl}
                                keepMounted
                                open={Boolean(editAnchorEl)}
                                onClose={editHandleClose}>
                                {sessionStorage.getItem('org') !== 'CPI-165' &&
                                    <>
                                        {regBtn && <MenuItem onClick={editPatientHandleClick}>Patient</MenuItem>}
                                        {maternalBtn &&
                                            <>
                                                <MenuItem onClick={editANCHandleClick}>ANC</MenuItem>
                                                <MenuItem onClick={editDeliHandleClick}>Delivery</MenuItem>
                                                <MenuItem onClick={editPNCHandleClick}>PNC</MenuItem>
                                                {sessionStorage.getItem('project') === 'P-001' ?
                                                    <MenuItem onClick={editMDSRHandleClick}>MDSR</MenuItem> : null}
                                            </>}
                                        {(SRHBtn && ICDBtn && !siriBtn) && <MenuItem onClick={editFPHandleClick}>FP</MenuItem>}
                                        {(SRHBtn && siriBtn && !ICDBtn) && <MenuItem onClick={editRHHandleClick}>RH</MenuItem>}
                                        {(SRHBtn && !ICDBtn && !siriBtn) &&
                                            <>
                                                <MenuItem onClick={editFPHandleClick}>FP</MenuItem>
                                                <MenuItem onClick={editRHHandleClick}>RH</MenuItem>
                                            </>
                                        }
                                        {GMBtn && <MenuItem onClick={editGMHandleClick}>GM</MenuItem>}
                                        <MenuItem onClick={editCFRMHandleClick}>CFRM</MenuItem>
                                        <MenuItem onClick={editEWARHandleClick}>EWAR</MenuItem>
                                    </>}
                                {(sessionStorage.getItem('org') === 'CPI-01' || sessionStorage.getItem('org') === 'CPI-11' || sessionStorage.getItem('org') === 'CPI-165') &&
                                    <><MenuItem onClick={editHEHandleClick}>HE</MenuItem></>}
                                {sessionStorage.getItem('org') !== 'CPI-165' &&
                                    <>
                                        {imamBtn &&
                                            <>
                                                <MenuItem onClick={editOTPHandleClick}>IMAM-OTP</MenuItem>
                                                <MenuItem onClick={editSFPHandleClick}>IMAM-SFP</MenuItem>
                                                <MenuItem onClick={editHTSHandleClick}>HTS Register</MenuItem>
                                            </>}
                                        {IPDBtn &&
                                            <>
                                                <MenuItem onClick={editOPDHandleClick}>OPD(Medical)</MenuItem>
                                                <MenuItem onClick={editSurgeryHandleClick}>Surgery</MenuItem>
                                                <MenuItem onClick={editIPDHandleClick}>IPD</MenuItem>
                                            </>}
                                        {deleteRegBtn &&
                                            <>
                                                <MenuItem onClick={deleteServiceHandleClick}>Delete Service</MenuItem>
                                                <MenuItem onClick={deleteRegisterHandleClick}>Delete Register</MenuItem>
                                            </>}
                                    </>}

                            </StyledMenu>
                        </Toolbar>
                    </AppBar>
                </Card>
                <main style={{ textAlign: 'center' }}>

                    {dashboardShow && <EntryHomePageDashboard />}

                    {registerShow && <RegisterForm editPage={false} />}
                    {patientEditShow && <EditPatientForm />}

                    {RHShow && dialogOpen === false && <RHServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} />}
                    {dialogOpen && <CustomIDSearchDialog onClose={setDialogCloseControl} open={setDialogOpenControl} clinic={clinicData} village={villageData} />}
                    {gmDialogOpen && <CustomIDSearchDialog onClose={setGMDialogCloseControl} open={setGMDialogOpenControl} clinic={clinicData} village={villageData} diagnosisData={diagnosisData} />}
                    {ageDialogOpen && <CustomIDSearchDialog onClose={setAgeDialogCloseControl} open={setAgeDialogOpenControl} patient={editAgeData} />}
                    {deleteServiceDialogOpen && <CustomIDSearchDialog onClose={setDeleteServiceCloseControl} open={setDeleteServiceOpenControl} patient={deleteServiceData} />}
                    {deleteRegisterDialogOpen && <CustomIDSearchDialog onClose={setDeleteRegisterCloseControl} open={setDeleteRegisterOpenControl} patient={deleteRegisterData} />}

                    {RHEditShow && <EditRHForm></EditRHForm>}
                    {RHEditFormShow && <RHServiceEditForm></RHServiceEditForm>}

                    {FPShow && dialogOpen === false && <FPServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} />}
                    {FPEditShow && <EditFPForm></EditFPForm>}
                    {FPEditFormShow && <FPServiceEditForm></FPServiceEditForm>}

                    {ANCShow && dialogOpen === false && <ANCServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} />}
                    {ANCEditShow && <EditANCForm></EditANCForm>}
                    {ANCEditFormShow && <ANCServiceEditForm></ANCServiceEditForm>}

                    {delShow && dialogOpen === false && <DeliveryServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} />}
                    {DelEditShow && <EditDeliveryForm></EditDeliveryForm>}
                    {DelEditFormShow && <DeliveryServiceEditForm></DeliveryServiceEditForm>}

                    {PNCShow && dialogOpen === false && <PNCServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} />}
                    {PNCEditShow && <EditPNCForm></EditPNCForm>}
                    {PNCEditFormShow && <PNCServiceEditForm></PNCServiceEditForm>}

                    {MDSRShow && <MDSRServiceForm />}
                    {MDSREditShow && <EditMDSRForm />}
                    {MDSREditFormShow && <MDSRServiceEditForm />}

                    {GMShow && gmDialogOpen === false && <GMServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} diagnosisData={diagnosisData} imciData={imciData} hptDiagnosisData={hptDiagnosisData} />}
                    {GMEditShow && <EditGMForm></EditGMForm>}
                    {GMEditFormShow && <GMServiceEditForm></GMServiceEditForm>}

                    {EWARShow && <EWARForm />}
                    {EWAREditShow && <EditEWARForm />}
                    {EWAREditFormShow && <EWAREditForm />}

                    {HEShow && <HEForm />}
                    {HEEditShow && <EditHEForm />}
                    {HEEditFormShow && <HEEditForm />}

                    {CFRMShow && <CFRMForm />}
                    {CFRMEditShow && <EditCFRMForm />}
                    {CFRMEditFormShow && <CFRMEditForm />}

                    {OTPShow && <OTPForm />}
                    {OTPEditShow && <EditOTPForm />}
                    {OTPEditFormShow && <OTPEditForm />}

                    {SFPShow && <SFPForm />}
                    {SFPEditShow && <EditSFPForm />}
                    {SFPEditFormShow && <SFPEditForm />}

                    {HTSShow && <HTSForm />}
                    {HTSEditShow && <EditHTSForm />}
                    {HTSEditFormShow && <HTSEditForm />}

                    {IPDShow && gmDialogOpen === false && <IPDServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} diagnosisData={diagnosisData} imciData={imciData} hptDiagnosisData={hptDiagnosisData} />}
                    {IPDEditShow && <EditIPDForm />}
                    {IPDEditFormShow && <IPDServiceEditForm />}

                    {OPDShow && gmDialogOpen === false && <GMServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} diagnosisData={diagnosisData} imciData={imciData} hptDiagnosisData={hptDiagnosisData} />}
                    {OPDEditShow && <EditGMForm />}

                    {surgeryShow && gmDialogOpen === false && <GMServiceForm gender={patientGender} patient={patient} serviceType={serviceType} clinic={clinicData} village={villageData} diagnosisData={diagnosisData} imciData={imciData} hptDiagnosisData={hptDiagnosisData} />}
                    {surgeryEditShow && <EditGMForm />}

                    {ANCReportShow && <ANCReport />}
                    {DelReportShow && <DeliveryReport />}
                    {PNCReportShow && <PNCReport />}
                    {FPReportShow && <FPReport />}
                    {RHReportShow && <RHReport />}
                    {GMReportShow && <GMReport />}
                    {HCReportShow && <HeadCountReport />}
                    {FPRHReportShow && <FPRHReport />}
                    {(exportProvidedShow && sessionStorage.getItem('role') === '2' && sessionStorage.getItem('project') !== 'P-999') && <ExportByProvidedDate />}
                    {(exportProvidedShow && (sessionStorage.getItem("project")==="P-999" || sessionStorage.getItem("project")==="P-060")) && <ExportByProvidedDateDashboard />}
                    {exportInsertShow && <ExportCFRM />}
                    {exportEWARShow && <ExportEWAR />}
                    {exportHEShow && <ExportHE />}
                    {ANCVisitShow && <ANCVisitCount />}
                    {exportMDSRShow && <ExportMDSR />}
                    {ageEditShow && <ExportRegisterOnly />}
                    {dailyReportShow && <UIDailyReport />}
                    {/* {ageEditShow && <ExportSQL/>} */}
                    {/*  {ageEditShow && ageDialogOpen === false && <EditAgeForm patient={editAgeData} />} */}
                    {deleteServiceShow && deleteServiceDialogOpen === false && <DeleteServiceForm patient={deleteServiceData} />}
                    {deleteRegisterShow && deleteRegisterDialogOpen === false && <DeleteRegisterForm patient={deleteRegisterData} />}
                </main>

            </div>
            {!CFRMShow && !imamBtn && <Typography variant="body1" align="center" style={{ color: 'gray', padding: '0.5%', position: 'relative', bottom: 0 }}>
                Copyright © HMIS Facility Base System 2018-{new Date().getFullYear()}. </Typography>}
        </div>

    );
}
export default EntryPageMenu